import { Component } from 'react';
import {Switch, Route } from 'react-router-dom';
import React from 'react';
import LoginForm from './LoginForm';
import Authenticate from './Authenticate';
import ForgotPassword from './ForgotPassword';
import {withRouter} from 'react-router';
class Login extends Component {
    render() {
        return (
            <Switch>
                <Route
                    exact
                    path='/wachtwoord-vergeten'
                    render={ (props) =>
                            <ForgotPassword />
                            }/>
                <Route
                    exact
                    path='/login'
                    render={ (props) =>
                            <LoginForm />
                            }/>
                <Route
                    exact
                    path='/login/verification'
                    render={ (props) =>
                            <Authenticate />
                            }/>

            </Switch>
        )
    }
}



export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/components/Login/index.js